import React, { useState, useEffect, useCallback } from 'react';
import SinglePageComplete from './components/SinglePageComplete';
import UnifiedLogin from './components/UnifiedLogin';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const handleLogout = useCallback(() => {
    // Clear all auth data
    sessionStorage.removeItem('userAuthenticated');
    sessionStorage.removeItem('adminAuthenticated');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('username');
    sessionStorage.removeItem('fullName');
    sessionStorage.removeItem('userRole');
    sessionStorage.removeItem('userAuthExpiresAt');
    sessionStorage.removeItem('adminAuthExpiresAt');
    sessionStorage.removeItem('session_expiry');

    setIsAuthenticated(false);
    setIsAdmin(false);
  }, []);

  const checkAuthStatus = useCallback(() => {
    try {
      const userAuth = sessionStorage.getItem('userAuthenticated') === 'true';
      const adminAuth = sessionStorage.getItem('adminAuthenticated') === 'true';
      const userRole = sessionStorage.getItem('userRole');
      const user = sessionStorage.getItem('username');
      const expiry = sessionStorage.getItem('session_expiry');

      if (!user || (expiry && Date.now() > parseInt(expiry, 10))) {
        handleLogout();
        return;
      }

      if (userAuth || adminAuth) {
        const expiresAtKey = adminAuth ? 'adminAuthExpiresAt' : 'userAuthExpiresAt';
        const expiresAtRaw = sessionStorage.getItem(expiresAtKey);
        if (expiresAtRaw) {
          const expiresAt = parseInt(expiresAtRaw, 10);
          if (!isNaN(expiresAt) && expiresAt > 0 && Date.now() > expiresAt) {
            handleLogout();
            return;
          }
        }
      }

      if (adminAuth && userRole === 'admin') {
        setIsAuthenticated(true);
        setIsAdmin(true);
      } else if (userAuth && userRole === 'user') {
        setIsAuthenticated(true);
        setIsAdmin(false);
      } else {
        if (!userAuth && !adminAuth) {
          setIsAuthenticated(false);
          setIsAdmin(false);
        }
      }
    } catch (error) {
      console.error('Error checking auth status:', error);
    }
  }, [handleLogout]);

  // Check authentication status on mount and periodically
  useEffect(() => {
    checkAuthStatus();
    const interval = setInterval(checkAuthStatus, 5 * 60000);
    return () => clearInterval(interval);
  }, [checkAuthStatus]);

  const handleLoginSuccess = (role) => {
    setIsAuthenticated(true);
    setIsAdmin(role === 'admin');
  };



  // If not authenticated, show unified login screen
  if (!isAuthenticated) {
    return <UnifiedLogin onLoginSuccess={handleLoginSuccess} />;
  }

  // If authenticated, show main application
  return <SinglePageComplete isAdmin={isAdmin} onLogout={handleLogout} />;
}

export default App;
